import * as React from 'react';
import { ReactComponent as SvgRatingEmpty } from '@img/icons/rating-empty.svg';
import { ReactComponent as SvgRatingHalf } from '@img/icons/rating-half.svg';
import { ReactComponent as SvgRatingFull } from '@img/icons/rating-full.svg';
import { ReactComponent as SvgHomeViews } from '@img/icons/homeviews.svg';
import S from './ReviewScore.styles';
const getStarIcons = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        if (rating >= i) {
            stars.push(React.createElement(SvgRatingFull, { key: i }));
        }
        else if (rating >= i - 0.5) {
            stars.push(React.createElement(SvgRatingHalf, { key: i }));
        }
        else {
            stars.push(React.createElement(SvgRatingEmpty, { key: i }));
        }
    }
    return stars;
};
const ReviewScore = ({ rating, reviews, text, link, variant = 'default', theme = 'dark' }) => {
    return (React.createElement(S.Container, { href: link, rel: "noreferrer", target: "_blank", "data-variant": variant, "data-theme": theme },
        React.createElement(S.Grid, null,
            React.createElement(S.StarContainer, null, getStarIcons(rating)),
            React.createElement(S.RatingText, null,
                rating,
                " (",
                reviews,
                " reviews)")),
        React.createElement(S.TextContainer, null,
            React.createElement(S.Text, null, text),
            React.createElement(SvgHomeViews, null))));
};
export const ReviewScoreHomepage = ({ rating, reviews, link, theme = 'dark' }) => {
    return (React.createElement(S.Container, { href: link, rel: "noreferrer", target: "_blank", "data-variant": "inline", "data-theme": theme },
        React.createElement(S.Grid, null,
            React.createElement(S.StarContainer, null, getStarIcons(rating))),
        React.createElement(S.HomepageTextContainer, null,
            React.createElement(SvgHomeViews, null),
            React.createElement(S.RatingText, null,
                rating,
                " (",
                reviews,
                " reviews)"))));
};
export default ReviewScore;
